import pure from "./higher-order/pure";
import React from "react";

export default pure(function FormError({ error, name }) {
  if (!error) {
    return null;
  }
  var lines = error.map((message) => (
    <div key={message}>
      {name}

      {" "}

      {message}
      .
    </div>
  ));

  return (
    <div className="form_message form_message--has-error">
      {lines}
    </div>
  );
});
